var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6387,
    cy: 30.2529,
    r: 29.9707,
    fill: "#F8E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2469 41.3993V38.3274C43.2469 36.698 42.5996 35.1353 41.4474 33.9831C40.2953 32.8309 38.7326 32.1837 37.1032 32.1837H24.8156C23.1862 32.1837 21.6235 32.8309 20.4713 33.9831C19.3192 35.1353 18.6719 36.698 18.6719 38.3274V41.3993M37.1032 19.8961C37.1032 23.2892 34.3525 26.0399 30.9594 26.0399C27.5663 26.0399 24.8156 23.2892 24.8156 19.8961C24.8156 16.503 27.5663 13.7524 30.9594 13.7524C34.3525 13.7524 37.1032 16.503 37.1032 19.8961Z",
    stroke: "#D32028",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e5586f3aa59927cf31e5d2a54241e685.svg";
export { ForwardRef as ReactComponent };